'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.create = create;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _ircFramework = require('irc-framework');

var _ircFramework2 = _interopRequireDefault(_ircFramework);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _IrcdDiffs = require('@/helpers/IrcdDiffs');

var IrcdDiffs = _interopRequireWildcard(_IrcdDiffs);

var _TypingMiddleware = require('./TypingMiddleware');

var _TypingMiddleware2 = _interopRequireDefault(_TypingMiddleware);

var _ChathistoryMiddleware = require('./ChathistoryMiddleware');

var _ChathistoryMiddleware2 = _interopRequireDefault(_ChathistoryMiddleware);

var _ServerConnection = require('./ServerConnection');

var ServerConnection = _interopRequireWildcard(_ServerConnection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function create(state, network) {
    var networkid = network.id;

    var clientOpts = {
        host: network.connection.server,
        port: network.connection.port,
        tls: network.connection.tls,
        path: network.connection.path,
        password: network.password,
        nick: network.nick,
        username: network.username || network.nick,
        gecos: network.gecos || 'https://kiwiirc.com/',
        version: null,
        auto_reconnect: false,
        encoding: network.connection.encoding
    };

    var ircClient = new _ircFramework2.default.Client(clientOpts);
    ircClient.requestCap('znc.in/self-message');

    ircClient.requestCap('message-tags');
    ircClient.use((0, _ChathistoryMiddleware2.default)());
    ircClient.use(clientMiddleware(state, network));
    ircClient.use((0, _TypingMiddleware2.default)());

    var originalIrcClientConnect = ircClient.connect;
    ircClient.connect = function connect() {
        ircClient.options.host = network.connection.server;
        ircClient.options.port = network.connection.port;
        ircClient.options.tls = network.connection.tls;
        ircClient.options.path = network.connection.path;
        ircClient.options.password = network.password;
        ircClient.options.nick = network.connection.nick;
        ircClient.options.username = network.username || network.connection.nick;
        ircClient.options.gecos = network.gecos || 'https://kiwiirc.com/';
        ircClient.options.encoding = network.connection.encoding;

        state.$emit('network.connecting', { network: network });

        if (!network.connection.direct) {
            ircClient.options.transport = ServerConnection.createChannelConstructor(state.settings.kiwiServer, (window.location.hash || '').substr(1), networkid);
        } else {
            ircClient.options.transport = undefined;
        }

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        originalIrcClientConnect.apply(ircClient, args);
    };

    ircClient.on('raw', function (event) {
        if (!network.setting('show_raw') && !state.setting('showRaw')) {
            return;
        }

        var buffer = state.getOrAddBufferByName(networkid, '*raw');
        state.addMessage(buffer, {
            time: Date.now(),
            nick: '',
            message: (event.from_server ? '[S] ' : '[C] ') + event.line
        });
    });

    ircClient.on('typing', function (event) {
        var user = state.getUser(network.id, event.nick);
        if (user) {
            user.typingStatus(event.target, event.status);
        }
    });

    return ircClient;
}

function clientMiddleware(state, network) {
    var networkid = network.id;

    var numConnects = 0;
    var isRegistered = false;

    return function middlewareFn(client, rawEvents, parsedEvents) {
        parsedEvents.use(parsedEventsHandler);
        rawEvents.use(rawEventsHandler);

        client.on('connecting', function () {
            network.state_error = '';
            network.state = 'connecting';
            network.last_error = '';
            network.last_error_numeric = 0;
        });

        client.on('connected', function () {
            network.state_error = '';
            network.state = 'connected';

            network.buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                var messageBody = TextFormatting.formatText('network_connected', {
                    text: TextFormatting.t('connected')
                });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '',
                    message: messageBody,
                    type: 'connection',
                    type_extra: 'connected'
                });
            });
        });

        client.on('socket close', function (err) {
            isRegistered = false;
            network.state = 'disconnected';
            network.state_error = err || '';

            network.buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                buffer.joined = false;
                buffer.clearUsers();

                var messageBody = TextFormatting.formatText('network_disconnected', {
                    text: TextFormatting.t('disconnected')
                });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '',
                    message: messageBody,
                    type: 'connection',
                    type_extra: 'disconnected'
                });
            });
        });
    };

    function rawEventsHandler(command, event, rawLine, client, next) {
        if (command === '002') {
            var param = event.params[1] || '';
            var m = param.match(/running version (.*)$/);
            network.ircd = m ? m[1] : '';
        }

        state.$emit('irc.raw', command, event, network);
        state.$emit('irc.raw.' + command, command, event, network);

        if (command === '904') {
            if (state.setting('disconnectOnSaslFail')) {
                network.ircClient.connection.end();
                network.last_error = 'Invalid login';
            }

            var serverBuffer = network.serverBuffer();
            state.addMessage(serverBuffer, {
                time: Date.now(),
                nick: '*',
                message: 'Invalid login'
            });
        }

        if (command === 'CAP' && network.setting('show_raw_caps')) {
            var params = [].concat((0, _toConsumableArray3.default)(event.params));
            if (params[params.length - 1].indexOf(' ') > -1) {
                params[params.length - 1] = ':' + params[params.length - 1];
            }

            var buffer = network.serverBuffer();
            state.addMessage(buffer, {
                time: Date.now(),
                nick: '',
                message: event.command + ' ' + params.join(' ')
            });
        }

        next();
    }

    function parsedEventsHandler(command, event, client, next) {
        var ircEventObj = { handled: false };
        state.$emit('irc.' + command, event, network, ircEventObj);
        if (ircEventObj.handled) {
            next();
            return;
        }

        if (event && event.command === 'CONTROL') {
            next();
            return;
        }

        var eventTime = event && event.time ? network.ircClient.network.timeToLocal(event.time) : Date.now();
        var serverTime = event && event.time || 0;

        if (command === 'channel_redirect') {
            var b = network.bufferByName(event.from);
            if (b) {
                b.flags.redirect_to = event.to;
            }
        }

        if (command === 'registered') {
            isRegistered = true;
            network.nick = event.nick;
            state.addUser(networkid, { nick: event.nick, username: client.user.username });

            var serverBuffer = network.serverBuffer();
            state.addMessage(serverBuffer, {
                time: Date.now(),
                nick: '',
                message: TextFormatting.t('connected_to', { network: client.network.name })
            });

            client.raw('WHO ' + event.nick);

            if (network.auto_commands) {
                network.auto_commands.split('\n').forEach(function (line) {
                    state.$emit('input.raw', line[0] === '/' ? line : '/' + line);
                });
            }

            if (!network.connection.bncnetid) {
                network.buffers.forEach(function (buffer) {
                    if (buffer.isChannel() && buffer.enabled) {
                        client.join(buffer.name, buffer.key);
                    }
                });
            }

            numConnects++;
        }

        if (command === 'server options') {
            if (client.network.name !== 'Network') {
                network.name = client.network.name;
            }
        }

        if (command === 'unknown command') {
            if (event.command === '486') {
                var targetNick = event.params[1];
                var buffer = state.getOrAddBufferByName(network.id, targetNick);
                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '*',
                    message: event.params[2],
                    type: 'error'
                });
            } else {
                var _buffer = network.serverBuffer();
                var message = '';

                if (!event.command.match(/^\d+$/)) {
                    message += event.command + ' ';
                }

                var containsNick = event.params[0] === network.ircClient.user.nick;
                var isChannelMessage = network.isChannelName(event.params[1]);

                if (containsNick && isChannelMessage) {
                    var channelBuffer = network.bufferByName(event.params[1]);
                    if (channelBuffer) {
                        _buffer = channelBuffer;
                    }
                    message += event.params.slice(2).join(', ');
                } else if (containsNick) {
                    message += event.params.slice(1).join(', ');
                } else {
                    message += event.params.join(', ');
                }

                state.addMessage(_buffer, {
                    nick: '',
                    message: message
                });
            }
        }

        if (command === 'message') {
            var isPrivateMessage = false;
            var bufferName = event.from_server ? '*' : event.target;

            if (!event.from_server && event.target === client.user.nick) {
                isPrivateMessage = true;
                bufferName = event.nick;
            }

            if (event.nick.toLowerCase() === 'chanserv' && isPrivateMessage && event.message[0] === '[') {
                bufferName = event.message.substr(1, event.message.indexOf(']') - 1);
            }

            if (event.type === 'notice') {
                var existingBuffer = state.getBufferByName(networkid, bufferName);
                var noticeActiveBuffer = state.setting('noticeActiveBuffer');
                var activeBuffer = state.getActiveBuffer();
                var hasActiveBuffer = activeBuffer && activeBuffer.networkid === networkid;

                if (!existingBuffer) {
                    if (noticeActiveBuffer && hasActiveBuffer) {
                        bufferName = activeBuffer.name;
                    } else {
                        bufferName = '*';
                    }
                }
            }

            var PM_BLOCK_BLOCKED = false;

            var PM_BLOCK_REQUIRES_CHECK = null;

            var pmBlock = network.isNickExemptFromPmBlocks(event.nick);
            var blockNewPms = state.setting('buffers.block_pms');
            var _buffer2 = state.getBufferByName(networkid, bufferName);

            var textFormatType = 'privmsg';
            if (event.type === 'action') {
                textFormatType = 'action';
            } else if (event.type === 'notice') {
                textFormatType = 'notice';
            }

            var messageBody = TextFormatting.formatText(textFormatType, {
                nick: event.nick,
                username: event.ident,
                host: event.hostname,
                text: event.message
            });

            var _message = {
                time: eventTime,
                server_time: serverTime,
                nick: event.nick,
                message: messageBody,
                type: event.type,
                tags: event.tags || {}
            };

            if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_BLOCKED) {
                return;
            }

            if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_REQUIRES_CHECK) {
                var awaitingWhois = !!_lodash2.default.find(network.pendingPms, { nick: event.nick });
                network.pendingPms.push({ bufferName: bufferName, message: _message });

                if (awaitingWhois) {
                    return;
                }

                network.ircClient.whois(event.nick, event.nick, function (whoisData) {
                    network.pendingPms.forEach(function (pm, idx, obj) {
                        var nickLower = pm.message.nick.toLowerCase();
                        if (nickLower === whoisData.nick.toLowerCase()) {
                            if (whoisData.operator) {
                                _buffer2 = state.getOrAddBufferByName(network.id, pm.bufferName);
                                state.addMessage(_buffer2, pm.message);
                            }
                            obj.splice(idx, 1);
                        }
                    });
                });

                return;
            }

            if (!_buffer2) {
                _buffer2 = state.getOrAddBufferByName(networkid, bufferName);
            }
            state.addMessage(_buffer2, _message);
        }

        if (command === 'wallops') {
            var _buffer3 = state.getOrAddBufferByName(networkid, '*');
            var _messageBody = TextFormatting.formatText('wallops', {
                text: event.message
            });

            state.addMessage(_buffer3, {
                time: eventTime,
                server_time: serverTime,
                nick: event.nick,
                message: _messageBody,
                type: 'wallops'
            });
        }

        if (command === 'join') {
            if (event.nick === client.user.nick) {
                network.buffers.forEach(function (b) {
                    if ((b.flags.redirect_to || '').toLowerCase() === event.channel.toLowerCase()) {
                        state.$delete(b.flags, 'redirect_to');
                        b.rename(event.channel);
                    }
                });
            }

            var _buffer4 = state.getOrAddBufferByName(networkid, event.channel);

            if (_buffer4.name !== event.channel) {
                _buffer4.rename(event.channel);
            }

            state.addUserToBuffer(_buffer4, {
                nick: event.nick,
                username: event.ident,
                host: event.hostname,
                realname: event.gecos,
                account: event.account || ''
            });

            if (event.nick === client.user.nick) {
                _buffer4.enabled = true;
                _buffer4.joined = true;
                _buffer4.flags.channel_badkey = false;
                network.ircClient.raw('MODE', event.channel);
                network.ircClient.who(event.channel);
            }

            var nick = _buffer4.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

            var _messageBody2 = TextFormatting.formatAndT('channel_join', null, 'has_joined', { nick: nick });

            state.addMessage(_buffer4, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody2,
                type: 'traffic',
                type_extra: 'join'
            });
        }
        if (command === 'kick') {
            var _buffer5 = state.getOrAddBufferByName(networkid, event.channel);
            state.removeUserFromBuffer(_buffer5, event.kicked);

            var _messageBody3 = '';

            if (event.kicked === client.user.nick) {
                _buffer5.joined = false;
                _buffer5.clearUsers();

                _messageBody3 = TextFormatting.formatAndT('channel_selfkick', { reason: event.message }, 'kicked_you_from', {
                    nick: TextFormatting.formatUser(event),
                    channel: event.channel
                });
            } else {
                _messageBody3 = TextFormatting.formatAndT('channel_kicked', { reason: event.message }, 'was_kicked_from', {
                    nick: event.kicked,
                    channel: event.channel,
                    chanop: TextFormatting.formatUser(event.nick)
                });
            }

            state.addMessage(_buffer5, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody3,
                type: 'traffic',
                type_extra: 'kick'
            });
        }
        if (command === 'part') {
            var _buffer6 = state.getBufferByName(networkid, event.channel);
            if (!_buffer6) {
                return;
            }

            state.removeUserFromBuffer(_buffer6, event.nick);
            if (event.nick === client.user.nick) {
                _buffer6.joined = false;
                _buffer6.enabled = false;
                _buffer6.clearUsers();
            }

            var remainingBuffers = state.getBuffersWithUser(networkid, event.nick);
            if (remainingBuffers.length === 0) {
                state.removeUser(networkid, {
                    nick: event.nick
                });
            }

            var _nick = _buffer6.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

            var _messageBody4 = TextFormatting.formatAndT('channel_part', { reason: event.message }, 'has_left', { nick: _nick });

            state.addMessage(_buffer6, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody4,
                type: 'traffic',
                type_extra: 'part'
            });
        }
        if (command === 'quit') {
            var buffers = state.getBuffersWithUser(networkid, event.nick);

            buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                if (event.nick === client.user.nick) {
                    buffer.joined = false;
                    buffer.clearUsers();
                }

                var nick = buffer.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

                var messageBody = TextFormatting.formatAndT('channel_quit', { reason: event.message }, 'has_left', { nick: nick });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: event.nick,
                    message: messageBody,
                    type: 'traffic',
                    type_extra: 'quit'
                });
            });

            state.removeUser(networkid, {
                nick: event.nick
            });
        }

        if (command === 'invite') {
            var _buffer7 = network.serverBuffer();
            state.addMessage(_buffer7, {
                nick: '*',
                message: TextFormatting.t('invited_you', {
                    nick: event.nick,
                    channel: event.channel
                })
            });
        }

        if (command === 'account') {
            state.addUser(networkid, { nick: event.nick, account: event.account || '' });
        }

        if (command === 'whois') {
            var obj = {
                nick: event.nick,
                host: event.hostname,
                username: event.ident,
                away: event.away || '',
                realname: event.real_name,
                hasWhois: true
            };

            ['actual_host', 'helpop', 'bot', 'server', 'server_info', 'operator', 'channels', 'modes', 'idle', 'logon', 'registered_nick', 'account', 'secure', 'special'].forEach(function (prop) {
                if (typeof event[prop] !== 'undefined') {
                    obj[prop] = event[prop];
                }
            });

            state.addUser(networkid, obj);
        }

        if (command === 'away') {
            state.addUser(networkid, {
                nick: event.nick,
                away: event.message || ''
            });
            var _buffer8 = state.getActiveBuffer();
            if (_buffer8 && event.nick === network.nick) {
                network.away = 'away';
                state.addMessage(_buffer8, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '*',
                    type: 'presence',
                    message: event.message
                });
            }
        }

        if (command === 'back') {
            state.addUser(networkid, {
                nick: event.nick,
                away: ''
            });
            var _buffer9 = state.getActiveBuffer();
            if (_buffer9 && event.nick === network.nick) {
                network.away = '';
                state.addMessage(_buffer9, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '*',
                    type: 'presence',
                    message: event.message
                });
            }
        }

        if (command === 'wholist') {
            state.usersTransaction(networkid, function (users) {
                event.users.forEach(function (eventUser) {
                    var userObj = {
                        nick: eventUser.nick,
                        host: eventUser.hostname || undefined,
                        username: eventUser.ident || undefined,
                        away: eventUser.away ? 'Away' : '',
                        realname: eventUser.real_name,
                        account: eventUser.account || undefined
                    };
                    var user = state.addUser(networkid, userObj, users);
                    if (!user) {
                        return;
                    }

                    var buffer = network.bufferByName(eventUser.channel);
                    if (!user.buffers[buffer.id]) {
                        return;
                    }

                    var modes = user.buffers[buffer.id].modes;
                    eventUser.channel_modes.forEach(function (mode) {
                        if (modes.indexOf(mode) === -1) {
                            modes.push(mode);
                        }
                    });
                });
            });
        }

        if (command === 'channel list start') {
            network.channel_list_cache = [];
            network.channel_list_state = 'updating';
        }
        if (command === 'channel list') {
            network.channel_list_state = 'updating';

            var filteredEvent = _lodash2.default.filter(event, function (o) {
                return o.channel !== '*';
            });

            network.channel_list_cache = (network.channel_list_cache || []).concat(filteredEvent);
        }
        if (command === 'channel list end') {
            network.channel_list = network.channel_list_cache || [];
            network.channel_list_state = 'updated';
            delete network.channel_list_cache;
        }

        if (command === 'motd') {
            var _buffer10 = network.serverBuffer();
            var _messageBody5 = TextFormatting.formatText('motd', {
                text: event.motd
            });
            state.addMessage(_buffer10, {
                time: eventTime,
                server_time: serverTime,
                nick: '',
                message: _messageBody5,
                type: 'motd'
            });
        }

        if (command === 'nick in use' && !client.connection.registered) {
            var newNick = client.user.nick + rand(1, 100);
            var _messageBody6 = TextFormatting.formatAndT('nickname_alreadyinuse', null, 'nick_in_use_retrying', { nick: client.user.nick, newnick: newNick });

            network.buffers.forEach(function (b) {
                state.addMessage(b, {
                    time: Date.now(),
                    nick: '',
                    message: _messageBody6,
                    type: 'error'
                });
            });

            client.changeNick(newNick);
        }

        if (command === 'nick in use' && client.connection.registered) {
            var _buffer11 = state.getActiveBuffer();
            _buffer11 && state.addMessage(_buffer11, {
                time: Date.now(),
                nick: '',
                type: 'error',
                message: 'The nickname \'' + event.nick + '\' is already in use!'
            });
        }

        if (command === 'nick') {
            if (event.nick === client.user.nick) {
                network.nick = event.new_nick;
            }

            state.changeUserNick(networkid, event.nick, event.new_nick);

            var _messageBody7 = TextFormatting.formatAndT('nick_changed', null, 'now_known_as', { nick: event.nick, newnick: event.new_nick });

            var _buffers = state.getBuffersWithUser(networkid, event.new_nick);
            _buffers.forEach(function (buffer) {
                state.addMessage(buffer, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '',
                    message: _messageBody7,
                    type: 'nick'
                });
            });
        }

        if (command === 'userlist') {
            var _buffer12 = state.getOrAddBufferByName(networkid, event.channel);
            var hadExistingUsers = (0, _keys2.default)(_buffer12.users).filter(function (u) {
                return u !== network.ircClient.user.nick;
            }).length > 0;
            var users = [];
            event.users.forEach(function (user) {
                users.push({
                    user: {
                        nick: user.nick,
                        username: user.ident,
                        hostname: user.hostname
                    },
                    modes: user.modes
                });
            });
            state.addMultipleUsersToBuffer(_buffer12, users);

            if (!hadExistingUsers && network.ircClient.chathistory.isSupported()) {
                var correctBuffer = _buffer12.isChannel() || _buffer12.isQuery();

                if (correctBuffer) {
                    _buffer12.requestLatestScrollback();
                }
            }
        }

        if (command === 'channel info') {
            var _buffer13 = network.bufferByName(event.channel);
            if (!_buffer13) {
                return;
            }

            if (event.modes) {
                var modeStrs = [];

                event.modes.forEach(function (mode) {
                    var adding = mode.mode[0] === '+';
                    var modeChar = mode.mode.substr(1);

                    if (adding) {
                        state.$set(_buffer13.modes, modeChar, mode.param);
                    } else if (!adding) {
                        state.$delete(_buffer13.modes, modeChar);
                    }

                    modeStrs.push(mode.mode + (mode.param ? ' ' + mode.param : ''));
                });

                if (_buffer13.flags.requested_modes) {
                    state.addMessage(_buffer13, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '*',
                        message: _buffer13.name + ' ' + modeStrs.join(', ')
                    });
                }
            }

            if (event.created_at) {
                _buffer13.created_at = new Date(event.created_at * 1000);
            }

            if (event.created_at && _buffer13.flags.requested_modes) {
                var tFormat = _buffer13.setting('timestamp_full_format');
                var timeCreated = tFormat ? (0, _strftime2.default)(tFormat, new Date(event.created_at * 1000)) : new Date(event.created_at * 1000).toLocaleString();

                state.addMessage(_buffer13, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '*',
                    message: _buffer13.name + ' ' + timeCreated
                });
            }
        }

        if (command === 'mode') {
            var _buffer14 = network.bufferByName(event.target);
            var _modeStrs = {};
            if (_buffer14) {
                event.modes.forEach(function (mode) {
                    _modeStrs[mode.mode] = _modeStrs[mode.mode] || [];

                    var prefix = _lodash2.default.find(network.ircClient.network.options.PREFIX, {
                        mode: mode.mode[1]
                    });

                    if (prefix) {
                        var user = state.getUser(network.id, mode.param);
                        if (user) {
                            var adding = mode.mode[0] === '+';
                            var modes = user.buffers[_buffer14.id].modes;
                            var modeIdx = modes.indexOf(prefix.mode);

                            if (adding && modeIdx === -1) {
                                modes.push(prefix.mode);
                            } else if (!adding && modeIdx > -1) {
                                modes.splice(modeIdx, 1);
                            }
                        }

                        _modeStrs[mode.mode].push({ target: mode.param });
                    } else {
                        var _adding = mode.mode[0] === '+';
                        var modeChar = mode.mode.substr(1);

                        if (_adding) {
                            state.$set(_buffer14.modes, modeChar, mode.param);
                        } else if (!_adding) {
                            state.$delete(_buffer14.modes, modeChar);
                        }

                        _modeStrs[mode.mode].push({ target: _buffer14.name, param: mode.param });
                    }
                });

                var modeLocaleIds = {
                    '+o': 'modes_give_ops',
                    '-o': 'modes_take_ops',
                    '+h': 'modes_give_halfops',
                    '-h': 'modes_take_halfops',
                    '+v': 'modes_give_voice',
                    '-v': 'modes_take_voice',
                    '+a': 'modes_give_admin',
                    '-a': 'modes_take_admin',
                    '+q': 'modes_give_owner',
                    '-q': 'modes_take_owner',
                    '+b': 'modes_gives_ban',
                    '-b': 'modes_takes_ban'
                };

                if (!IrcdDiffs.isQChannelModeOwner(network)) {
                    delete modeLocaleIds['+q'];
                    delete modeLocaleIds['-q'];
                }
                if (!IrcdDiffs.isAChannelModeAdmin(network)) {
                    delete modeLocaleIds['+a'];
                    delete modeLocaleIds['-a'];
                }
                if (!IrcdDiffs.supportsHalfOp(network)) {
                    delete modeLocaleIds['+h'];
                    delete modeLocaleIds['-h'];
                }

                var modeLocaleDataBuilders = {
                    default: function _default(targets, mode) {
                        return {
                            mode: mode + (targets[0].param ? ' ' + targets[0].param : ''),
                            target: targets.map(function (t) {
                                return t.target;
                            }).join(', '),
                            nick: event.nick
                        };
                    },
                    b: function b(targets, mode) {
                        return {
                            mode: mode,
                            target: targets[0].param ? targets[0].param : '',
                            nick: event.nick
                        };
                    }
                };

                _lodash2.default.each(_modeStrs, function (targets, mode) {
                    var builders = modeLocaleDataBuilders;
                    var localeDataFn = builders[mode[1]] || builders.default;
                    var localeData = localeDataFn(targets, mode);

                    var localeKey = modeLocaleIds[mode] || 'modes_other';
                    var text = TextFormatting.t(localeKey, localeData);

                    var messageBody = TextFormatting.formatText('mode', {
                        nick: event.nick,
                        username: event.ident,
                        host: event.hostname,
                        target: targets.map(function (t) {
                            return t.target;
                        }).join(', '),
                        text: text
                    });
                    state.addMessage(_buffer14, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '',
                        message: messageBody,
                        type: 'mode'
                    });
                });
            } else {
                var modeslines = {};

                event.modes.forEach(function (mode) {
                    if (mode.param) {
                        modeslines[mode.mode] = ' ' + mode.param;
                    } else if (mode.mode[0] === '-') {
                        if (!modeslines['-']) {
                            modeslines['-'] = '';
                        }
                        modeslines['-'] += mode.mode.slice(1);
                    } else {
                        if (!modeslines['+']) {
                            modeslines['+'] = '';
                        }
                        if (mode.mode[0] === '+') {
                            modeslines['+'] += mode.mode.slice(1);
                        } else {
                            modeslines['+'] += mode.mode;
                        }
                    }
                });

                var _serverBuffer = network.serverBuffer();
                _lodash2.default.each(modeslines, function (mode, value) {
                    var text = TextFormatting.t('modes_other', {
                        nick: event.nick,
                        target: event.target,
                        mode: value + mode
                    });
                    var messageBody = TextFormatting.formatText('mode', {
                        nick: event.nick,
                        username: event.ident,
                        host: event.hostname,
                        target: event.target,
                        text: text
                    });
                    state.addMessage(_serverBuffer, {
                        time: Date.now(),
                        nick: '',
                        message: messageBody,
                        type: 'mode'
                    });
                });
            }
        }

        if (command === 'banlist') {
            var _buffer15 = state.getBufferByName(networkid, event.channel);
            if (_buffer15 && _buffer15.flags.requested_banlist) {
                if (!event.bans || event.bans.length === 0) {
                    state.addMessage(_buffer15, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '',
                        message: TextFormatting.t('bans_nobody'),
                        type: 'banlist'
                    });
                } else {
                    var banText = '';
                    _lodash2.default.each(event.bans, function (ban) {
                        var dateStr = new Date(ban.banned_at * 1000).toDateString();
                        banText += '+b ' + ban.banned + ' [by ' + ban.banned_by + ', ' + dateStr + ']\n';
                    });

                    state.addMessage(_buffer15, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '*',
                        message: banText,
                        type: 'banlist'
                    });
                }
                _buffer15.flags.requested_banlist = false;
            }
        }

        if (command === 'topic') {
            var _buffer16 = state.getOrAddBufferByName(networkid, event.channel);
            _buffer16.topic = event.topic || '';

            var _messageBody8 = '';

            if (event.nick) {
                _messageBody8 = TextFormatting.formatAndT('channel_topic', null, 'changed_topic_to', { nick: event.nick, topic: event.topic });
            } else if (_buffer16.topic.trim()) {
                _messageBody8 = TextFormatting.formatText('channel_topic', _buffer16.topic);
            }

            if (_messageBody8) {
                state.addMessage(_buffer16, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '',
                    message: _messageBody8,
                    type: 'topic'
                });
            }
        }

        if (command === 'ctcp response' || command === 'ctcp request') {
            var _buffer17 = network.bufferByName(event.target) || network.serverBuffer();
            var textFormatId = command === 'ctcp response' ? 'ctcp_response' : 'ctcp_request';
            var _messageBody9 = TextFormatting.formatText(textFormatId, {
                nick: event.nick,
                message: event.message,
                type: event.type
            });

            state.addMessage(_buffer17, {
                time: eventTime,
                server_time: serverTime,
                nick: '',
                message: _messageBody9,
                type: 'error'
            });

            if (command === 'ctcp request' && event.type === 'VERSION') {
                client.ctcpResponse(event.nick, 'VERSION', 'Kiwi IRC');
            }
        }

        if (command === 'nick invalid') {
            var _messageBody10 = TextFormatting.formatText('general_error', {
                text: event.reason
            });
            var _buffer18 = state.getActiveBuffer();
            state.addMessage(_buffer18, {
                time: eventTime,
                server_time: serverTime,
                nick: '',
                message: _messageBody10,
                type: 'error'
            });

            if (!isRegistered) {
                network.last_error_numeric = 432;
                network.last_error = event.reason;
                network.ircClient.quit();
            }
        }

        if (command === 'irc error') {
            var _buffer19 = void 0;
            if (event.channel || event.nick) {
                _buffer19 = state.getOrAddBufferByName(network.id, event.channel || event.nick);
            }
            if (!_buffer19) {
                _buffer19 = network.serverBuffer();
            }

            if (!_buffer19) {
                return;
            }

            if (event.error === 'bad_channel_key') {
                _buffer19.flags.channel_badkey = true;
            }

            if (event.reason && network.last_error_numeric !== 432) {
                if (!isRegistered) {
                    network.last_error = event.reason;
                }
                var _messageBody11 = TextFormatting.formatText('general_error', {
                    text: event.reason || event.error
                });
                state.addMessage(_buffer19, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '',
                    message: _messageBody11,
                    type: 'error'
                });
            }

            if (_buffer19.isChannel() && !_buffer19.joined) {
                _buffer19.enabled = false;
            }
        }

        next();
    }
}

function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IrcClient"]
window._kiwi_exports.libs.IrcClient = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/IrcClient.js
// module id = jnb6
// module chunks = 1